import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class RecruitmentOfferService {

  url = ConfigService.toApiUrl('recruitment-offers/');
  publicUrl = ConfigService.toApiUrl('recruitment-offers-public');

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this.url}`, ConfigService.addAction('list'));
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.addAction('show'));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.addAction('add'));
  }

  update(id: any, ressource: any) {
    ressource['_method'] = 'patch';
    return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete'));
  }

  setState(id: any, state: any) {
    return this.http.get<any>(`${ConfigService.toApiUrl('recruitment-offers-set-state')}/${id}/state/${state}`, ConfigService.addAction('status'));
  }

  // Public endpoints (no auth, no action header)
  publicGetAll() {
    return this.http.get<any>(`${this.publicUrl}`);
  }

  publicGet(id: any) {
    return this.http.get<any>(`${this.publicUrl}/${id}`);
  }
}
